import {RealDevice} from "dto/realdevice/devices"
import React, {useState} from "react"
import {NoneOperationCommentList} from "pages/dashboard/popup/noneOperation/NoneOperationCommentList"
import {RegisterNoneOperationComment} from "pages/dashboard/popup/noneOperation/RegisterNoneOperationComment"
import UpdateNoneOperationComment from "pages/dashboard/popup/noneOperation/UpdateNoneOperationComment"
import styled from "styled-components"

type NoneOpeationCommentViewMode = "list" | "create" | "update"
export const NoneOperationCommentView = ({device}: { device: RealDevice }) => {
    const {communicationDevice: {eui}} = device
    const [viewMode, setViewMode] = useState<NoneOpeationCommentViewMode>("list")
    const [id, setId] = useState<number | null>(null)
    return (
        <div className="mainbody" style={{overflowY: "auto"}}>
            {viewMode === "list" &&
                <NoneOperationCommentList
                    selectItem={(id) => {
                        setId(id)
                        setViewMode("update")
                    }}
                    eui={eui}
                />
            }
            {viewMode === "create" &&
                <RegisterNoneOperationComment
                    eui={eui}
                    onSuccess={() => setViewMode("list")}
                    onCancel={() => setViewMode("list")}/>
            }
            {viewMode === "update" && id &&
                <UpdateNoneOperationComment
                    id={id}
                    onSuccess={() => setViewMode("list")}
                    onCancel={() => setViewMode("list")}/>
            }
            <CreateButtonBox>
                <button className="button is-info is-small" onClick={() => setViewMode("create")}>사유 등록</button>
            </CreateButtonBox>
        </div>
    )
}

const CreateButtonBox = styled.div`
  position: absolute;
  bottom: .5rem;
  right: 1.5rem;
`
